import { MessageSquareCode, Zap, Target, Brain } from "lucide-react";
import { Badge } from "@/components/ui/badge";

export const PromptEngHeroSection = () => {
  return (
    <section className="pt-24 pb-8 sm:pt-28 sm:pb-10">
      <div className="flex flex-wrap items-center gap-2 mb-4">
        <Badge variant="outline" className="text-primary border-primary/30 bg-primary/5">
          <MessageSquareCode className="w-3 h-3 mr-1" />
          AI Development
        </Badge>
        <Badge variant="outline" className="text-muted-foreground border-border">
          14 min read
        </Badge>
      </div>

      <h1 className="text-3xl sm:text-4xl md:text-5xl font-display font-bold text-foreground leading-tight mb-4">
        Prompt Engineering{" "}
        <span className="text-primary">for Developers</span>
      </h1>

      <p className="text-lg sm:text-xl text-muted-foreground leading-relaxed max-w-3xl mb-8">
        Master the art of prompting AI coding assistants. Learn techniques for code generation, 
        debugging, refactoring, and building complex features with AI.
      </p>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div className="bg-card rounded-xl border border-border p-4 text-center">
          <Target className="w-6 h-6 text-primary mx-auto mb-2" />
          <div className="text-2xl font-bold text-foreground">3x</div>
          <div className="text-sm text-muted-foreground">Better outputs</div>
        </div>
        <div className="bg-card rounded-xl border border-border p-4 text-center">
          <Zap className="w-6 h-6 text-chart-2 mx-auto mb-2" />
          <div className="text-2xl font-bold text-foreground">80%</div>
          <div className="text-sm text-muted-foreground">Fewer iterations</div>
        </div>
        <div className="bg-card rounded-xl border border-border p-4 text-center">
          <Brain className="w-6 h-6 text-chart-4 mx-auto mb-2" />
          <div className="text-2xl font-bold text-foreground">10+</div>
          <div className="text-sm text-muted-foreground">Techniques covered</div>
        </div>
        <div className="bg-card rounded-xl border border-border p-4 text-center">
          <MessageSquareCode className="w-6 h-6 text-chart-1 mx-auto mb-2" />
          <div className="text-2xl font-bold text-foreground">20+</div>
          <div className="text-sm text-muted-foreground">Example prompts</div>
        </div>
      </div>
    </section>
  );
};
